import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Grid, Header, Button, Segment, Divider } from "semantic-ui-react";
import { useMediaQuery } from "react-responsive";
import { closeModal } from "../../../../app/common/modals/modalSlice";
import ModalWrapper from "../../../../app/common/modals/modalWrapper";
import {
  getStateFormByTitleFromDb,
  updateStateFormInDb,
} from "../../../../app/firestore/firestoreService";

export default function SaveDataToFormConfirm({ doc, transaction, annots }) {
  const dispatch = useDispatch();
  const { currentUserProfile } = useSelector((state) => state.profile);
  const [processingMode, setProcessingMode] = useState(null);
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });

  function handleCancel() {
    dispatch(
      closeModal({
        modalType: "SaveDataToFormConfirm",
      })
    );
  }

  async function handleSave(mode) {
    setProcessingMode(mode);
    try {
      const title = doc.title.split(".")[0];
      const form = await getStateFormByTitleFromDb(title, currentUserProfile);
      if (form) {
        await updateStateFormInDb(
          form.id,
          {
            annotsInProgressSuggested: annots,
            annotsInProgressSuggestedMode: mode,
          },
          currentUserProfile
        );
        toast.success("Document successfully saved");
      }
      dispatch(
        closeModal({
          modalType: "SaveDataToFormConfirm",
        })
      );
    } catch (error) {
      toast.error(error.message);
    } finally {
      setProcessingMode(null);
    }
  }

  return (
    <ModalWrapper size="small">
      <Segment>
        <Grid>
          <Grid.Column width={16} className="zero bottom padding">
            <Header as="h2" color="blue" className="zero bottom margin">
              Save Data to Form
            </Header>
            <Divider className="zero bottom margin" />
          </Grid.Column>
          <Grid.Column width={16}>
            <p className="text-medium">
              Do Buyer and Seller each sign their own copy of this form, or
              does only one side sign (whichever side the agent represents on
              the transaction)?
            </p>
            <p className="text-small text-muted">
              Choosing "One Side Only" lets this single form replace having
              separate Buyer-version and Seller-version forms -- only the
              represented side's signature/date/checkbox annots will be used,
              even if the other party also exists on the transaction.
            </p>

            <Divider className="medium top margin" />

            <Button
              primary
              loading={processingMode === "both"}
              disabled={!!processingMode}
              type="button"
              floated={isMobile ? null : "right"}
              onClick={() => handleSave("both")}
              content="Both Sides Sign"
              className={isMobile ? "fluid medium bottom margin" : null}
            />

            <Button
              loading={processingMode === "oneSideOnly"}
              disabled={!!processingMode}
              type="button"
              floated={isMobile ? null : "right"}
              onClick={() => handleSave("oneSideOnly")}
              content="One Side Only"
              className={isMobile ? "fluid medium bottom margin" : null}
            />

            <Button
              disabled={!!processingMode}
              onClick={() => handleCancel()}
              type="button"
              floated={isMobile ? null : "right"}
              content="Cancel"
              className={isMobile ? "fluid medium" : null}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    </ModalWrapper>
  );
}
